/**文献标注侧边筛选栏 */
<template>
  <div class="aside-filter">
    <el-collapse v-model="activeFilters">
      <el-collapse-item title="标注类型" name="annotation-type">
        <div class="annotation-type filter-list">
          <div
            class="list-item"
            v-for="type in annotationType"
            :key="type.value"
            v-show="searchType == null"
            @click="handleSearchType(type)"
          >
            <div>{{ ANNOTATION_TYPE[type.label] }}</div>
            <div>（{{ type.value }}）</div>
          </div>
          <div class="list-item active" v-if="searchType">
            <div>{{ ANNOTATION_TYPE[searchType.label] }}</div>
            <div class="remove-search" @click="handleSearchType(null)">
              <i class="iconfont icon-cuowu" />
            </div>
          </div>
          <div class="empty" v-if="!listLoading && annotationType.length == 0">
            暂无类型
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="标注颜色" name="annotation-color">
        <div class="annotation-color filter-list">
          <div
            class="list-item"
            v-for="color in annotationColor"
            :key="color.value"
            v-show="searchColor == null"
            @click="handleSearchColor(color)"
          >
            <div>
              <i
                class="iconfont icon-color icon-yuandianda"
                :class="color.label"
              />
            </div>
            <div>（{{ color.value }}）</div>
          </div>
          <div class="list-item active" v-if="searchColor">
            <div>
              <i
                class="iconfont icon-color icon-yuandianda"
                :class="searchColor.label"
              />
            </div>
            <div class="remove-search" @click="handleSearchColor(null)">
              <i class="iconfont icon-cuowu" />
            </div>
          </div>
          <div class="empty" v-if="!listLoading && annotationColor.length == 0">
            暂无颜色
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="标注时间" name="annotation-time">
        <div class="annotation-time">
          <el-date-picker
            v-model="searchTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="handleSearchTime"
          />
          <!-- <el-date-picker
            v-model="searchStartTime"
            type="datetime"
            placeholder="开始时间"
            class="start-time"
          />
          <el-date-picker
            v-model="searchEndTime"
            type="datetime"
            placeholder="结束时间"
            class="end-time"
          />
          <el-button
            type="primary"
            class="search-button"
            @click="handleSearchTime()"
          >
            查找
          </el-button> -->
        </div>
      </el-collapse-item>
      <SearchCollapseItem
        ref="tagCollapseRef"
        class="annotation-tag"
        name="annotation-tag"
        title="标注标签"
        :data="annotationTag"
        :loading="tagListLoading"
        @active="handleChangeCollapse"
        @search="handleSearchTag"
      />
    </el-collapse>
  </div>
</template>

<script setup>
import {
  ref,
  defineEmits,
  defineProps,
  onMounted,
  watch,
  defineExpose,
  computed,
  nextTick,
} from "vue";
import { httpPost } from "@/api/httpService";
import { ElMessage } from "element-plus";
import SearchCollapseItem from "@/components/literature/SearchCollapseItem.vue";

const emits = defineEmits(["update-filter"]);

const props = defineProps({
  filterData: {
    type: Object,
    default: () => {},
  },
});

const activeFilters = ref([
  "annotation-type",
  "annotation-color",
  "annotation-time",
  "annotation-tag",
]);

const ANNOTATION_TYPE = {
  highlight: "高亮",
  underline: "下划线",
};

//标注类型
const searchType = ref(null);
const annotationType = ref([]);
const handleSearchType = (type) => {
  searchType.value = type;
  updateSearch();
  getData();
  getTagData();
};
//标注颜色
const searchColor = ref(null);
const annotationColor = ref([]);
const handleSearchColor = (color) => {
  searchColor.value = color;
  updateSearch();
  getData();
  getTagData();
};
//标注时间
const searchTime = ref(null);
const searchStartTime = ref(null);
const searchEndTime = ref(null);
const handleSearchTime = () => {
  // if (new Date(searchEndTime.value) < new Date(searchStartTime.value)) {
  //   ElMessage.warning("结束时间请晚于开始时间");
  //   return;
  // }
  if (searchTime.value) {
    searchStartTime.value = searchTime.value[0];
    searchEndTime.value = searchTime.value[1];
  } else {
    searchStartTime.value = null;
    searchEndTime.value = null;
  }
  updateSearch();
  getData();
  getTagData();
};
//标注标签
const searchTag = ref([]);
const annotationTag = ref([]);
const handleChangeCollapse = (value) => {
  if (!activeFilters.value.includes(value)) {
    activeFilters.value.push(value);
  }
};
const handleSearchTag = (selectTagItems) => {
  const selectTags = selectTagItems.map((item) => item.label);
  searchTag.value = selectTags;
  updateSearch();
  getData();
};
const updateSearch = () => {
  emits("update-filter", {
    markType: searchType.value ? searchType.value.label : null,
    markColor: searchColor.value ? searchColor.value.label : null,
    markBeginTime: searchStartTime.value,
    markEndTime: searchEndTime.value,
    markTag: searchTag.value.length > 0 ? searchTag.value : null,
  });
};

//获取筛选列表
const listLoading = ref(false);
const getData = async () => {
  listLoading.value = true;
  let params = {
    topicUidList: filterDataTemp.value.topicUidList || null,
    unChildUidList: filterDataTemp.value.unChildUidList || null,
    literatureTitle: filterDataTemp.value.literatureTitle || null,
    literatureAuthor: filterDataTemp.value.literatureAuthor || null,
    citation: filterDataTemp.value.citation || null,
    comment: filterDataTemp.value.comment || null,
    markType: searchType.value ? searchType.value.label : null,
    markColor: searchColor.value ? searchColor.value.label : null,
    markBeginTime: searchStartTime.value,
    markEndTime: searchEndTime.value,
    tagList: searchTag.value.length > 0 ? searchTag.value : null,
  };
  let res = await httpPost("/literatureMark/v1/searchFilterBar", params);
  if (res.code == 0) {
    const typeMap = res.data.markTypeMap || {};
    annotationType.value = Object.entries(typeMap).map(([label, value]) => ({
      label,
      value,
    }));
    const colorMap = res.data.markColorMap || {};
    annotationColor.value = Object.entries(colorMap).map(([label, value]) => ({
      label,
      value,
    }));
  }
  listLoading.value = false;
};
const tagListLoading = ref(false);
const tagCollapseRef = ref(null);
const getTagData = async () => {
  tagListLoading.value = true;
  let params = {
    topicUidList: filterDataTemp.value.topicUidList || null,
    unChildUidList: filterDataTemp.value.unChildUidList || null,
    literatureTitle: filterDataTemp.value.literatureTitle || null,
    literatureAuthor: filterDataTemp.value.literatureAuthor || null,
    citation: filterDataTemp.value.citation || null,
    comment: filterDataTemp.value.comment || null,
    markType: searchType.value ? searchType.value.label : null,
    markColor: searchColor.value ? searchColor.value.label : null,
    markBeginTime: searchStartTime.value,
    markEndTime: searchEndTime.value,
  };
  let res = await httpPost("/literatureMark/v1/searchTagFilterBar", params);
  if (res.code == 0) {
    const tagMap = res.data || {};
    annotationTag.value = Object.entries(tagMap).map(([label, value]) => ({
      label,
      value,
      ifChecked: searchTag.value.includes(label), //还原已选中的
    }));
    //如果有选中的进行了还原
    if (annotationTag.value.some((item) => item.ifChecked)) {
      nextTick(() => {
        tagCollapseRef.value.handleSearch();
      });
    }
  }
  tagListLoading.value = false;
};

//监听筛选条件
const filterDataTemp = ref({});
watch(
  () => props.filterData,
  (newVal, oldVal) => {
    if (newVal) {
      filterDataTemp.value = JSON.parse(JSON.stringify(newVal));
      getData();
      getTagData();
    }
  },
  { immediate: true, deep: true }
);

onMounted(() => {
  getData();
  getTagData();
});

defineExpose({ getData, getTagData });
</script>

<style lang="scss" scoped>
.aside-filter {
  height: 100%;
  padding: 0px 7px;
  :deep(.el-collapse) {
    .el-collapse-item {
      .el-collapse-item__header {
        font-size: 15px;
        height: 45px;
      }
      .el-collapse-item__content {
        padding-bottom: 5px;
      }
    }
  }
  .filter-list {
    font-size: 14px;
    .list-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 30px;
      cursor: pointer;
      border-radius: 5px;
      margin-bottom: 5px;
      padding: 0 0 0 5px;
    }
    .list-item:hover {
      background-color: rgba(213, 213, 213, 0.13);
    }
    .active {
      background-color: rgba(213, 213, 213, 0.13);
      .remove-search {
        margin-right: 8px;
        width: 16px;
        height: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
      }
      .remove-search:hover {
        background-color: #f0f0f0;
      }
    }
    .empty {
      color: #848486;
      font-size: 12px;
    }
  }
  .annotation-type {
    height: 70px;
  }
  .annotation-color {
    height: 140px;
    .icon-color {
      font-size: 24px;
    }
    .default {
      color: $annotation-default;
    }
    .red {
      color: $annotation-red;
    }
    .yellow {
      color: $annotation-yellow;
    }
    .green {
      color: $annotation-green;
    }
  }
  .annotation-time {
    :deep(.el-date-editor) {
      width: 205px;
      margin-bottom: 5px;
    }
    :deep(.el-range-editor.el-input__wrapper) {
      padding: 0 2px 0 5px;
    }
    // .search-button {
    //   width: 200px;
    // }
  }
  :deep(.search-header) {
    top: 8px;
  }
  .annotation-tag {
    position: relative;
    :deep(.list-content) {
      .list {
        height: calc(100vh - $header-height - 490px);
        .list-item {
          text-align: left;
        }
      }
      .list-bottom {
      }
    }
  }
  .empty {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #909399;
    font-size: 13px;
  }
}
</style>
